import { FC } from 'react';
import { formatAmount } from '../../helpers/number.helper';
import { cn } from '../../helpers';

interface LineProps {
  title?: string;
  value?: string | number | undefined;
  currency?: boolean;
  showArrow?: boolean;
  showAmount?: boolean;
  containerClass?: string;
  lineTitleClass?: string | null;
  lineValueClass?: string | null;
  floatEndClass?: boolean;
  showDot?: boolean;
}
export const Line: FC<LineProps> = ({
  title,
  value,
  containerClass,
  currency,
  showArrow = false,
  showAmount = false,
  lineTitleClass,
  lineValueClass,
  floatEndClass,
  showDot = false,
}: LineProps) => (
  <div>
    {showAmount ? (
      <div className="flex px-1 py-2">
        <span className="text-base font-normal text-text-neutral-40 ">
          {title}
          {': '}
          &nbsp;&nbsp;
        </span>
        <span className="text-base font-semibold text-text-neutral-12 ">
          {value}
        </span>
      </div>
    ) : (
      <div
        className={cn('flex flex-row px-3 gap-1 items-center', containerClass)}
      >
        <div className="flex flex-row items-center flex-grow ">
          <span
            className={cn(
              'text-base',
              lineTitleClass
                ? 'font-semibold text-text-neutral-12'
                : 'text-neutral-40',
              lineTitleClass,
            )}
          >
            {title}
          </span>
          {showDot && (
            <span className="flex w-3 h-3 ml-1 rounded-full bg-red-00" />
          )}
        </div>

        <div className="flex items-center justify-center gap-1 ">
          <span
            className={cn(
              !lineValueClass && 'text-base text-neutral-12',
              floatEndClass && 'text-end',
              'text-base',
              lineValueClass && 'text-neutral-40',
            )}
          >
            {currency ? formatAmount(Number(value)) : value}
          </span>
          {showArrow ? (
            <span className="icon icon-chevron-right text-blue-00 " />
          ) : null}
        </div>
      </div>
    )}
  </div>
);

Line.defaultProps = {
  title: '',
  value: '',
  currency: false,
  showArrow: false,
  containerClass: '',
  lineTitleClass: null,
  showAmount: false,
};
